export default "__VITE_ASSET__DHliPMxL__"